import classNames from 'classnames';
import { Controller, useFormContext } from 'react-hook-form';
import { FormControl } from '@mui/material';
import CustomDatePicker from '../CustomDatePicker';
import styles from './index.module.scss';
import { getDate } from '../../services/timeService';
import { dateTimeFormat } from '../../services/timeService/types';

const DateOfFallField = () => {
  const {
    register,
    control,
    formState: { errors },
  } = useFormContext();

  return (
    <FormControl
      error={!!errors?.dateOfFall}
      required
      className={classNames(styles.inputWrapper, {
        [styles.error]: errors?.dateOfFall,
      })}>
      <Controller
        render={({ field }) => (
          <CustomDatePicker
            label="Fall Date"
            {...register('dateOfFall', {
              required: 'Please enter a valid date',
            })}
            maxDate={getDate()}
            defaultValue={field.value ? getDate(field.value) : null}
            onChange={(date) => {
              field.onChange(date?.format(dateTimeFormat.SERVER_DATE_FORMAT));
            }}
            isRequired
            isError={!!errors?.dateOfFall}
            helperText={errors?.dateOfFall?.message as string}
            inputClassName={styles.inputField}
          />
        )}
        name="dateOfFall"
        control={control}
      />
    </FormControl>
  );
};
export default DateOfFallField;
